import { createFileRoute } from '@tanstack/react-router'
import { requirePermission } from '../../app/guards'
import { AgingPage } from '../../features/sales/aging-page'
import { agingSearchSchema } from '../../features/sales/search'

export const Route = createFileRoute('/_app/receivables-aging')({
  staticData: { crumb: 'receivablesAging' },
  validateSearch: agingSearchSchema,
  beforeLoad: ({ context }) => requirePermission(context.session, 'sales.read'),
  component: AgingPage,
})
